<template>
    <div class="session-closed-alert-modal modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-pdv-small modal-dialog-centered">
            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>

                <div class="main-content">
                    <img src="/images/iconos/clock-white.svg" alt="">

                    <h3>TU SESIÓN SE CERRÓ <br>POR INACTIVIDAD</h3>

                    <a href="#" @click="onContinue" data-dismiss="modal" class="btn-pdv-primary ">VOLVER AL INICIO</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        methods : {
            onContinue(){
                window.$('#helperSessionClosedModal')[0].click();
            }
        }
    }
</script>

<style scoped lang="scss">
    .session-closed-alert-modal {
        @include media-breakpoint-down(sm){
            padding-right: 0 !important;
        }
        .modal-pdv-small {
            max-width: 481px;
            .modal-content{
                background: #313541;
                padding: 64px 60px;
                border-radius: 1px;
                box-shadow: 0 0 12px 3px #00000038;
                min-height: 381px;
                
                button.close{
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    opacity: 1;
                    span{
                        font-size: 30px;
                        color: #fff;
                    }
                }
                .main-content{
                    text-align: center;
                    img{
                        width: 65px;
                        margin-bottom: 20px;
                    }
                    h3{
                        font-size: 20px;
                        line-height: 23px;
                        margin-bottom: 28px;
                        color: #fff;
                        @include alternative-bold;
                    }
                    .btn-pdv-primary{
                        padding: 14px 40px;
                    }
                }
            }

        }
    }

</style>